module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0138.jpg?v=3f4297f2";